import { FC, CSSProperties } from 'react';
import { useTheme } from '@material-ui/core';
import { IconLabelBox } from '../../IconLabelBox';
import { KoFilledIcon } from './Icons';
import { useStyles } from './style';
import { WbInfoTooltip } from '../../WbInfoTooltip';

interface Props {
  style?: CSSProperties;
  variant?: 'reduced' | 'default';
}

export const ErrorIcon: FC<Props> = ({ style, variant = 'default' }) => {
  const theme = useTheme();
  const classes = useStyles();

  return (
    <WbInfoTooltip
      title="Failed. You need to solve the errors reported since they will prevent the deployment"
      icon={
        <span>
          {variant === 'reduced' ? (
            <KoFilledIcon
              htmlColor={theme.palette.error.main}
              className={classes.icon}
              style={style}
            />
          ) : (
            <IconLabelBox
              label="Error"
              backgroundColor={theme.palette.error.main}
              value="KO"
            />
          )}
        </span>
      }
    />
  );
};
